import React from 'react'
import { FaCoffee } from 'react-icons/fa'

interface BuyMeACoffeeButtonProps {
  username?: string
  className?: string
}

export const BuyMeACoffeeButton: React.FC<BuyMeACoffeeButtonProps> = ({
  username = 'idavid',
  className = '',
}) => {
  return (
    <a
      href={`https://www.buymeacoffee.com/${username}`}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center px-4 py-2 bg-[#FFDD00] hover:bg-[#FFED4E] text-black font-medium rounded-lg transition-all duration-200 shadow-md hover:shadow-lg ${className}`}
      style={{
        textDecoration: 'none',
      }}
    >
      <span
        className="inline-flex items-center mr-2"
        style={{ fontSize: '20px' }}
      >
        {React.createElement(FaCoffee as any)}
      </span>
      <span className="text-sm font-semibold">Hívj meg egy kávéra!</span>
    </a>
  )
}
